import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function MarketPositionByGeography({ marketByGeography, compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const [chartData, setChartData] = useState({});

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];

  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "geographic_segment", label: "Segment Name" },
        { key: "geography_market_size", label: "Market Size", width: "120px" },
        { key: "geography_cagr", label: "CAGR", width: "100px" },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
        },
      ];
      setHiddenColumns([]);
      setSidebarColumns([]);
      setColumns(allMetrics);
    } else {
      allMetrics = [
        // { key: "geographic_segment", label: "Segment Name" },
        { key: "geography_market_size", label: "Market Size", width: "120px" },
        { key: "geography_cagr", label: "CAGR", width: "100px" },
        // {
        //   key: "company_market_share",
        //   label: "Company Market Share",
        //   width: "140px",
        // },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
        },
        { key: "company_position", label: "Company Focus" },
        { key: "key_customer_segments", label: "Key Customer Segments" },
        { key: "key_products", label: "Key Products" },
        { key: "strategic_significance", label: "Strategic Significance" },
      ];
      setHiddenColumns([
        "geography_market_size",
        "geography_cagr",
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
      setSidebarColumns([
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
      setColumns(allMetrics);
    }
  }, [compView]);

  const dummyData = [
    {
      primary_market: {
        value: "Adhesives & Sealants Market",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      global_market_size: {
        value: "$63.4B globally",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      taylor_position: {
        value: "Small Player",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      competitive_ranking: {
        value: "Top 50+ player",
      },
      strategic_significance: {
        value: "Global industry context",
      },
    },
    // Second entry (Post-Acute Care) → similar structure
  ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(marketByGeography);
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   marketByGeography?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={marketByGeography?.[0]?.response?.["tableComments"] || ""}
      />
    );

    let tempChartData = { data_set: [] };
    transformed.forEach((geographyData) => {
      tempChartData.data_set.push({
        geography_segment: geographyData.geography_segment?.value || "",
        geography_market_size: parseFloat(
          (geographyData.geography_market_size?.value !== "Undisclosed"
            ? geographyData.geography_market_size?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
        geography_cagr: parseFloat(
          (geographyData.geography_cagr?.value !== "Undisclosed"
            ? geographyData.geography_cagr?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
      });
    });

    if (tempChartData.data_set.length > 0) {
      setChartData(tempChartData);
      // console.log("TECH CHART DATA: ", tempChartData);
    }
  }, [marketByGeography]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      // title="Market Position - By Geography"
      // title="By Geography – North America"
      title="By Geography"
      subtitle=""
      // belowTableDescription="The shocking reality: Taylor's estimated $300M [1][3] revenue represents just 0.47% of the $63.4B [2] global market, yet they've built a sustainable business by owning specific premium segments completely. This reveals their true competitive advantage isn't scale - it's specialization depth that larger players like H.B. Fuller struggle to replicate without cannibalizing their own volume-based strategies."
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={columns}
      rowIdentifier="geography_segment"
      // extraIdentifierColumns={[
      //   { key: "geography_market_size", label: "Size" },
      //   { key: "geography_cagr", label: "CAGR" },
      // ]}
      // hiddenColumns={["geography_market_size", "geography_cagr"]}
      hiddenColumns={hiddenColumns}
      sidecardColumns={sidebarColumns}
      actions={actions}
      // chartId="market_position_by_geography_bubble_chart"
      // chartData={chartData}
      // chartType="bubble_chart"
      // xField="geography_market_size"
      // yField="geography_cagr"
      // nameField="geography_segment"
      // sizeField="geography_market_size"
      // colorField="bubble_color"
      // xAxisLabel="Geographic Size (Bn)"
      // yAxisLabel="CAGR (%)"
    />
  );
}

export default MarketPositionByGeography;
